import React, { useState, useEffect, useCallback } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate, useNavigate } from 'react-router-dom';
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { AppProvider, useApp } from './AppContext';
import Login from './components/login';
import Dashboard from './components/Dashboard';
import ZRNotification from './components/Zunftrat/zrNotification'; 
import ZRNotificationCreate from './components/Zunftrat/zrNotificationCreate'; 
import InstallPrompt from './components/InstallPrompt';
import Footer from './components/Footer';
import Impressum from './components/impressum';
import Datenschutz from './components/datenschutz';
import SwapBoerse from './components/workAssignment/srvSwapBoerse';
import SRVMyWorkAssignmentsPage from './components/workAssignment/srvMyWorkAssignmentsPage';


import './components/css/App.css';
import cfg from './config';
import AdminForms from './components/Admin/AdminForms';
import ZRLicense from './components/Zunftrat/zrLicense';
import MyData from './components/myData';
import ZRMember from './components/Zunftrat/zrMember'
import ZRMemberCreate from './components/Zunftrat/zrMemberCreate'
import ZRHaes from './components/Zunftrat/zrHaes'
import ZRHaesCreate from './components/Zunftrat/zrHaesCreate'
import ZRPersonnelFileCreate from './components/Zunftrat/zrPersonnelFileCreate';
import Service from './components/Service';
import SRVApplyHaes from './components/srvApplyHaes';
import ZRHaesApplyEdit from './components/Zunftrat/zrHaesApplyEdit'
import ZRWorkAssignment from './components/Zunftrat/zrWorkAssignment';
import ZRCreateWorkAssignment from './components/Zunftrat/zrCreateWorkAssignment';
import ZRCalendar from './components/Zunftrat/zrCalendar';
import ZRMoveList from './components/Zunftrat/ZRMoveList';
import ZRMoveEdit from './components/Zunftrat/zrMoveEdit'
import ZRMoveBookings from './components/Zunftrat/zrMoveBookings';
import MoveTable from './components/MoveTable';
import MyQRCode from './components/MyQrCode'
import ZRQRReader from './components/Zunftrat/zrQRReader';
import SRVSparePartEdit from './components/srvSparePartEdit';
import ZRDownload from './components/Zunftrat/zrDownload';
import DownloadList from './components/DownloadList';
import ZRSwapRequestOverview from './components/Zunftrat/zrSwapRequestOverview';
import ZRQRScanLog from './components/Zunftrat/zrQRScanLog';
import ZRCostumeTypeManagers from './components/Zunftrat/zrCostumeTypeManagers';
import AdminQRScanLog from './components/Admin/adminQRScanLog';
import AdminConfig from './components/Admin/AdminConfig';
import AdminFeatures from './components/Admin/AdminFeatures';
import PasswordReset from './components/PasswordReset';
import ZRStatistics from './components/Zunftrat/zrStatistics';
import ErrorBoundary from './components/ErrorBoundary';
import EmailVerification from './components/EmailVerification';
import Notifications from './components/Notifications';
import api from './components/axiosSetup';
import DemoBanner from './components/DemoBanner';
import Changelog from './components/Changelog';
import AdminChangelog from './components/Admin/AdminChangelog';
import AdminAnalytics from './components/Admin/AdminAnalytics';
import ZRAuditLog from './components/Zunftrat/zrAuditLog';
import ZRPolls from './components/Zunftrat/zrPolls';
import Polls from './components/Polls';
import ZRTaskList from './components/Zunftrat/zrTaskList';
import MyTasks from './components/myTasks';
import ChangePasswordForced from './components/ChangePasswordForced';
import Onboarding from './components/Onboarding';






import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
import 'react-toastify/dist/ReactToastify.css';
<link
  rel="stylesheet"
  href="https://cdn.jsdelivr.net/npm/bootstrap-icons@1.11.3/font/bootstrap-icons.css"
/>


// Komponente für den geschützten Zugriff
const ProtectedRoute = ({ element, redirectTo, checkIsZunftrat, zunftratOnly, checkIsAdmin, adminOnly }) => {
  const [isLoading, setIsLoading] = useState(true);
  // null = noch unklar. Nur ein ausdrueckliches false heisst "darf nicht".
  const [isZunftrat, setIsZunftrat] = useState(null);
  const [isAdmin, setIsAdmin] = useState(null);
  const [unklar, setUnklar] = useState(false);
  const token = localStorage.getItem('authToken');

  useEffect(() => {
    let abgebrochen = false;

    // Bei einem technischen Fehler einmal nachfassen, bevor jemand mit dem
    // Hinweis auf fehlende Rechte weggeschickt wird.
    const frageNach = async (pruefung) => {
      let ergebnis = await pruefung();
      if (ergebnis === null) {
        await new Promise(r => setTimeout(r, 800));
        ergebnis = await pruefung();
      }
      return ergebnis;
    };

    const fetchStatus = async () => {
      if (!token) { setIsLoading(false); return; }
      let konnteNichtPruefen = false;
      try {
        if (zunftratOnly && checkIsZunftrat) {
          const wert = await frageNach(checkIsZunftrat);
          if (wert === null) konnteNichtPruefen = true;
          if (!abgebrochen) setIsZunftrat(wert);
        }
        if (adminOnly && checkIsAdmin) {
          const wert = await frageNach(checkIsAdmin);
          if (wert === null) konnteNichtPruefen = true;
          if (!abgebrochen) setIsAdmin(wert);
        }
      } catch (error) {
        console.error('Fehler beim Abrufen des Zugriffsstatus:', error);
        konnteNichtPruefen = true;
      }
      if (abgebrochen) return;
      setUnklar(konnteNichtPruefen);
      setIsLoading(false);
    };

    fetchStatus();
    return () => { abgebrochen = true; };
  }, [token, checkIsZunftrat, zunftratOnly, checkIsAdmin, adminOnly]);

  if (isLoading) return <p>Laden...</p>;
  if (!token) return <Navigate to={redirectTo} />;

  // Liess sich der Status nicht ermitteln, ist das ein technisches Problem -
  // und keine Aussage ueber die Rechte. Entsprechend lautet die Meldung.
  if (unklar)
    return <Navigate to="/dashboard" state={{
      message: 'Die Zugriffsrechte konnten gerade nicht geprüft werden. Bitte versuche es noch einmal.',
    }} />;

  if (zunftratOnly && isZunftrat === false)
    return <Navigate to="/dashboard" state={{ message: `Diese Seite ist ${cfg.adminRoleName} vorbehalten.` }} />;
  if (adminOnly && isAdmin === false)
    return <Navigate to="/dashboard" state={{ message: "Kein Zugriff — Admin erforderlich." }} />;

  return element;
};

const App = () => {
  const { wartung, lizenzFehler, isOn } = useApp();
  const [token, setToken] = useState(localStorage.getItem('authToken') || null);
  const navigate = useNavigate();

  useEffect(() => {
    setToken(localStorage.getItem('authToken'));
  }, []);

  // Wichtig ist der Unterschied zwischen "darf nicht" und "wissen wir gerade
  // nicht". Vorher lieferten beide Pruefungen bei jedem Fehler false - ein
  // Aussetzer im Netz, eine gerade laufende Token-Erneuerung oder die
  // Anfragebremse sahen damit aus wie fehlende Rechte, und der Nutzer landete
  // mit "Diese Seite ist ... vorbehalten" auf dem Dashboard. null heisst:
  // unklar, bitte noch einmal versuchen.
  const checkIsAdmin = useCallback(async () => {
    try {
      const { data } = await api.get('/api/navbar-admin');
      return data.isAdmin === 1;
    } catch (err) {
      return err.response?.status === 403 ? false : null;
    }
  }, []);

  const checkIsZunftrat = useCallback(async () => {
    try {
      const { data } = await api.get('/api/navbar-zunftrat');
      return data.isZunftrat === 1;
    } catch (err) {
      return err.response?.status === 403 ? false : null;
    }
  }, []);

  if (wartung === null) return (
    <div className="d-flex justify-content-center align-items-center" style={{ minHeight: '100vh', background: '#121212' }}>
      <div className="spinner-border text-light" role="status" />
    </div>
  );

  if (wartung !== false) return (
    <div style={{
      minHeight: '100vh',
      background: 'linear-gradient(135deg, #0d0d0d 0%, #1a1a2e 100%)',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      padding: '2rem'
    }}>
      <div style={{
        background: 'rgba(255,255,255,0.04)',
        border: '1px solid rgba(255,255,255,0.1)',
        borderRadius: '1.25rem',
        padding: '3rem 2.5rem',
        maxWidth: 480,
        width: '100%',
        textAlign: 'center',
        boxShadow: '0 8px 40px rgba(0,0,0,0.5)'
      }}>
        <div style={{
          width: 72, height: 72,
          borderRadius: '50%',
          background: 'rgba(255,193,7,0.12)',
          border: '2px solid rgba(255,193,7,0.3)',
          display: 'flex', alignItems: 'center', justifyContent: 'center',
          margin: '0 auto 1.5rem',
          fontSize: '2rem'
        }}>⚙️</div>
        <h2 style={{ color: '#fff', fontWeight: 700, marginBottom: '0.75rem' }}>Wartungsarbeiten</h2>
        <p style={{ color: 'rgba(255,255,255,0.5)', lineHeight: 1.6, marginBottom: '2rem' }}>
          {wartung}
        </p>
        <button
          className="btn btn-warning"
          style={{ fontWeight: 600, paddingInline: '2rem', borderRadius: '0.6rem' }}
          onClick={() => { sessionStorage.removeItem('wartungBypass'); window.location.reload(); }}
        >
          Erneut versuchen
        </button>
      </div>
    </div>
  );

  if (lizenzFehler) return (
    <div style={{
      minHeight: '100vh',
      background: 'linear-gradient(135deg, #0d0d0d 0%, #1a0a0a 100%)',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      padding: '2rem'
    }}>
      <div style={{
        background: 'rgba(255,255,255,0.03)',
        border: '1px solid rgba(248,113,113,0.25)',
        borderRadius: '1.25rem',
        padding: '3rem 2.5rem',
        maxWidth: 520,
        width: '100%',
        textAlign: 'center',
        boxShadow: '0 8px 40px rgba(0,0,0,0.6)'
      }}>
        <div style={{
          width: 72, height: 72,
          borderRadius: '50%',
          background: 'rgba(248,113,113,0.1)',
          border: '2px solid rgba(248,113,113,0.35)',
          display: 'flex', alignItems: 'center', justifyContent: 'center',
          margin: '0 auto 1.5rem',
          fontSize: '2rem'
        }}>🔒</div>
        <h2 style={{ color: '#fff', fontWeight: 700, marginBottom: '0.5rem' }}>
          {lizenzFehler.status === 'expired' ? 'Lizenz abgelaufen' : 'Keine gültige Lizenz'}
        </h2>
        <p style={{ color: 'rgba(248,113,113,0.85)', fontSize: '0.9rem', marginBottom: '0.5rem' }}>
          {lizenzFehler.message}
        </p>
        <p style={{ color: 'rgba(255,255,255,0.4)', lineHeight: 1.7, marginBottom: '1.25rem', fontSize: '0.9rem' }}>
          Um diese Anwendung zu nutzen, ist eine gültige Lizenz erforderlich.<br />
          Bitte wenden Sie sich an den Hersteller:
        </p>
        {cfg.vendorEmail && (
          <div style={{
            display: 'inline-block',
            background: 'rgba(248,113,113,0.08)',
            border: '1px solid rgba(248,113,113,0.3)',
            color: '#fca5a5',
            borderRadius: '0.6rem',
            padding: '0.6rem 1.5rem',
            fontWeight: 600,
            fontSize: '0.95rem',
            marginBottom: '1rem',
            userSelect: 'all',
          }}>
            {cfg.vendorEmail}
          </div>
        )}
        <div>
          <button
            style={{
              background: 'none', border: 'none',
              color: 'rgba(255,255,255,0.25)', fontSize: '0.78rem',
              cursor: 'pointer', marginTop: '0.5rem'
            }}
            onClick={() => window.location.reload()}
          >
            Seite neu laden
          </button>
        </div>
      </div>
    </div>
  );

  const isDemoMode = process.env.REACT_APP_DEMO_MODE === 'true';

  return (
    <div className="App bg-dark text-white" style={isDemoMode ? { paddingTop: '34px' } : undefined}>
      <DemoBanner />
      <div className="main-content">
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/passwort-vergessen" element={<PasswordReset />} />
          <Route path="/passwort-reset" element={<PasswordReset />} />
          <Route path="/email-verifizieren" element={<EmailVerification />} />
          <Route 
            path="/dashboard"
            element={token ? <Dashboard /> : <Navigate to="/login" state={{ message: "Zugriff verweigert! Du musst eingeloggt sein, um auf das Dashboard zuzugreifen." }} />} 
          />
           <Route 
            path="/meine-daten"
            element={token ? <MyData /> : <Navigate to="/login" state={{ message: "Zugriff verweigert! Du musst eingeloggt sein, um auf deine Daten zuzugreifen." }} />} 
          />
          <Route 
            path="/service"
            element={token ? <Service /> : <Navigate to="/login" state={{ message: "Zugriff verweigert! Du musst eingeloggt sein, um auf die Deinstleistungen zuzugreifen." }} />} 
          />
           <Route
            path="/my-qr-code"
            element={!token ? <Navigate to="/login" state={{ message: "Zugriff verweigert! Du musst eingeloggt sein, um auf die Deinstleistungen zuzugreifen." }} /> : !isOn('Modul_Veranstaltungen') ? <Navigate to="/dashboard" state={{ message: 'Das Modul Veranstaltungen & QR-Codes ist deaktiviert.' }} /> : <MyQRCode />}
          />
           <Route
            path="/move-table"
            element={!token ? <Navigate to="/login" /> : !isOn('Modul_Veranstaltungen') ? <Navigate to="/dashboard" state={{ message: 'Das Modul Veranstaltungen ist deaktiviert.' }} /> : <MoveTable />}
          />
          <Route
            path="/service-apply-haes"
            element={!token ? <Navigate to="/login" /> : !isOn('Modul_Haes') ? <Navigate to="/dashboard" state={{ message: `Das Modul ${cfg.costumeTermPlural} ist deaktiviert.` }} /> : <SRVApplyHaes />}
          />
          <Route
            path="/service-order-spare-parts"
            element={!token ? <Navigate to="/login" /> : !isOn('Modul_Haes') ? <Navigate to="/dashboard" state={{ message: `Das Modul ${cfg.costumeTermPlural} ist deaktiviert.` }} /> : <SRVSparePartEdit />}
          />
              <Route
            path="/downloads"
            element={token ? <DownloadList /> : <Navigate to="/login" />}
          />

          <Route
            path="/meine-einsaetze"
            element={!token ? <Navigate to="/login" /> : !isOn('Modul_Arbeitseinsatz') ? <Navigate to="/dashboard" state={{ message: 'Das Modul Arbeitseinsatz ist deaktiviert.' }} /> : <SRVMyWorkAssignmentsPage />}
          />
          <Route
            path="/swap-boerse"
            element={!token ? <Navigate to="/login" /> : !isOn('Modul_Arbeitseinsatz') ? <Navigate to="/dashboard" state={{ message: 'Das Modul Arbeitseinsatz ist deaktiviert.' }} /> : <SwapBoerse />}
          />
          

          <Route 
            path="/zr-notification"
            element={
              <ProtectedRoute
                element={<ZRNotification />}
                redirectTo="/dashboard"
                checkIsZunftrat={checkIsZunftrat}
                zunftratOnly={true} // Nur für Zunftrat-Mitglieder zugänglich
              />
            }
            
          />
           <Route
            path="/zr-calendar"
            element={!isOn('Modul_Veranstaltungen') ? <Navigate to="/dashboard" /> :
              <ProtectedRoute element={<ZRCalendar />} redirectTo="/dashboard" checkIsZunftrat={checkIsZunftrat} zunftratOnly={true} />
            }
          />
          <Route
            path="/zr-move-booking-analysis"
            element={!isOn('Modul_Veranstaltungen') ? <Navigate to="/dashboard" /> :
              <ProtectedRoute element={<ZRMoveBookings />} redirectTo="/dashboard" checkIsZunftrat={checkIsZunftrat} zunftratOnly={true} />
            }
          />

           <Route 
            path="/zr-qr-reader"
            element={
              <ProtectedRoute
                element={<ZRQRReader />}
                redirectTo="/dashboard"
                checkIsZunftrat={checkIsZunftrat}
                zunftratOnly={true} // Nur für Zunftrat-Mitglieder zugänglich
              />
            }
          />
           <Route
            path="/zr-moves"
            element={!isOn('Modul_Veranstaltungen') ? <Navigate to="/dashboard" /> :
              <ProtectedRoute element={<ZRMoveList />} redirectTo="/dashboard" checkIsZunftrat={checkIsZunftrat} zunftratOnly={true} />
            }
          />
          <Route 
            path="/zr-member"
            element={
              <ProtectedRoute
                element={<ZRMember />}
                redirectTo="/dashboard"
                checkIsZunftrat={checkIsZunftrat}
                zunftratOnly={true} // Nur für Zunftrat-Mitglieder zugänglich
              />
            }
          />
          <Route
            path="/zr-haes"
            element={!isOn('Modul_Haes') ? <Navigate to="/dashboard" /> :
              <ProtectedRoute element={<ZRHaes />} redirectTo="/dashboard" checkIsZunftrat={checkIsZunftrat} zunftratOnly={true} />
            }
          />

          <Route
            path="/zr-workassignment"
            element={!isOn('Modul_Arbeitseinsatz') ? <Navigate to="/dashboard" /> :
              <ProtectedRoute element={<ZRWorkAssignment />} redirectTo="/dashboard" checkIsZunftrat={checkIsZunftrat} zunftratOnly={true} />
            }
          />
          <Route
            path="/zr-workassignment-create"
            element={!isOn('Modul_Arbeitseinsatz') ? <Navigate to="/dashboard" /> :
              <ProtectedRoute element={<ZRCreateWorkAssignment />} redirectTo="/dashboard" checkIsZunftrat={checkIsZunftrat} zunftratOnly={true} />
            }
          />
          
            <Route 
            path="/edit-haes-apply"
            element={
              <ProtectedRoute
                element={<ZRHaesApplyEdit />}
                redirectTo="/dashboard"
                checkIsZunftrat={checkIsZunftrat}
                zunftratOnly={true} // Nur für Zunftrat-Mitglieder zugänglich
              />
            }
          />
           <Route 
            path="/zr-personnell-entry-create"
            element={
              <ProtectedRoute
                element={<ZRPersonnelFileCreate />}
                redirectTo="/dashboard"
                checkIsZunftrat={checkIsZunftrat}
                zunftratOnly={true} // Nur für Zunftrat-Mitglieder zugänglich
              />
            }
          />


            <Route
            path="/zr-notification-create"
            element={
              <ProtectedRoute
                element={<ZRNotificationCreate />}
                redirectTo="/dashboard"
                checkIsZunftrat={checkIsZunftrat}
                zunftratOnly={true}
              />
            }
          />
           <Route
            path="/zr-member-create"
            element={
              <ProtectedRoute
                element={<ZRMemberCreate />}
                redirectTo="/dashboard"
                checkIsZunftrat={checkIsZunftrat}
                zunftratOnly={true}
              />
            }
          />
          <Route
            path="/zr-haes-create"
            element={
              <ProtectedRoute
                element={<ZRHaesCreate />}
                redirectTo="/dashboard"
                checkIsZunftrat={checkIsZunftrat}
                zunftratOnly={true}
              />
            }
          />

          <Route
            path="/zr-move-edit"
            element={
              <ProtectedRoute
                element={<ZRMoveEdit />}
                redirectTo="/dashboard"
                checkIsZunftrat={checkIsZunftrat}
                zunftratOnly={true}
              />
            }
          />
           <Route 
            path="/zr-download"
            element={
              <ProtectedRoute
                element={<ZRDownload />}
                redirectTo="/dashboard"
                checkIsZunftrat={checkIsZunftrat}
                zunftratOnly={true} // Nur für Zunftrat-Mitglieder zugänglich
              />
            }
            
          />

            <Route
            path="/zr-swap-boerse"
            element={!isOn('Modul_Arbeitseinsatz') ? <Navigate to="/dashboard" /> :
              <ProtectedRoute element={<ZRSwapRequestOverview />} redirectTo="/dashboard" checkIsZunftrat={checkIsZunftrat} zunftratOnly={true} />
            }
          />

          <Route
            path="/zr-qr-scan-log"
            element={
              <ProtectedRoute
                element={<ZRQRScanLog />}
                redirectTo="/dashboard"
                checkIsZunftrat={checkIsZunftrat}
                zunftratOnly={true}
              />
            }
          />
          <Route
            path="/zr-costume-type-managers"
            element={
              <ProtectedRoute
                element={<ZRCostumeTypeManagers />}
                redirectTo="/dashboard"
                checkIsZunftrat={checkIsZunftrat}
                zunftratOnly={true}
              />
            }
          />
          <Route
            path="/zr-statistics"
            element={!isOn('Modul_Berichte') ? <Navigate to="/dashboard" /> :
              <ProtectedRoute element={<ZRStatistics />} redirectTo="/dashboard" checkIsZunftrat={checkIsZunftrat} zunftratOnly={true} />
            }
          />
          <Route
            path="/admin-qr-scan-log"
            element={
              <ProtectedRoute
                element={<AdminQRScanLog />}
                redirectTo="/login"
                checkIsAdmin={checkIsAdmin}
                adminOnly={true}
              />
            }
          />
          <Route
            path="/admin-config"
            element={
              <ProtectedRoute
                element={<AdminConfig />}
                redirectTo="/login"
                checkIsAdmin={checkIsAdmin}
                adminOnly={true}
              />
            }
          />
          <Route
            path="/admin-forms"
            element={
              <ProtectedRoute
                element={<AdminForms />}
                redirectTo="/login"
                checkIsAdmin={checkIsAdmin}
                adminOnly={true}
              />
            }
          />
          <Route
            path="/zr-license"
            element={
              <ProtectedRoute
                element={<ZRLicense />}
                redirectTo="/dashboard"
                checkIsZunftrat={checkIsZunftrat}
                zunftratOnly={true}
              />
            }
          />
          <Route
            path="/admin-features"
            element={
              <ProtectedRoute
                element={<AdminFeatures />}
                redirectTo="/login"
                checkIsAdmin={checkIsAdmin}
                adminOnly={true}
              />
            }
          />

          <Route
            path="/notifications"
            element={token ? <Notifications standalone={true} /> : <Navigate to="/login" />}
          />
          <Route
            path="/changelog"
            element={token ? <Changelog /> : <Navigate to="/login" />}
          />
          <Route
            path="/change-password-forced"
            element={token ? <ChangePasswordForced /> : <Navigate to="/login" />}
          />
          <Route
            path="/admin-changelog"
            element={
              <ProtectedRoute
                element={<AdminChangelog />}
                redirectTo="/login"
                checkIsAdmin={checkIsAdmin}
                adminOnly={true}
              />
            }
          />
          <Route
            path="/admin-analytics"
            element={
              <ProtectedRoute
                element={<AdminAnalytics />}
                redirectTo="/login"
                checkIsAdmin={checkIsAdmin}
                adminOnly={true}
              />
            }
          />
          <Route
            path="/zr-audit-log"
            element={
              <ProtectedRoute
                element={<ZRAuditLog />}
                redirectTo="/login"
                checkIsZunftrat={checkIsZunftrat}
                zunftratOnly={true}
              />
            }
          />
          <Route
            path="/zr-polls"
            element={
              <ProtectedRoute
                element={<ZRPolls />}
                redirectTo="/login"
                checkIsZunftrat={checkIsZunftrat}
                zunftratOnly={true}
              />
            }
          />
          <Route
            path="/abstimmungen"
            element={token ? <Polls /> : <Navigate to="/login" />}
          />
          <Route
            path="/zr-aufgaben"
            element={!isOn('Modul_Tasks') ? <Navigate to="/dashboard" state={{ message: 'Das Modul Aufgabenverwaltung ist deaktiviert.' }} /> :
              <ProtectedRoute element={<ZRTaskList />} redirectTo="/dashboard" checkIsZunftrat={checkIsZunftrat} zunftratOnly={true} />
            }
          />
          <Route
            path="/meine-aufgaben"
            element={!token ? <Navigate to="/login" /> : !isOn('Modul_Tasks') ? <Navigate to="/dashboard" state={{ message: 'Das Modul Aufgabenverwaltung ist deaktiviert.' }} /> : <MyTasks />}
          />
          <Route path="/" element={token ? <Navigate to="/dashboard" /> : <Navigate to="/login" />} />
          <Route path="/impressum" element={<Impressum />} />
          <Route path="/datenschutz" element={<Datenschutz />} />
          <Route path="/onboarding" element={<Onboarding />} />
          <Route path="*" element={
            <div className="d-flex align-items-center justify-content-center min-vh-100">
              <div className="text-center">
                <h1 style={{ fontSize: '6rem', fontWeight: 700, color: '#facc15' }}>404</h1>
                <h3 className="mb-3">Seite nicht gefunden</h3>
                <a href="/dashboard" className="btn btn-warning">Zum Dashboard</a>
              </div>
            </div>
          } />
        </Routes>
      </div>

      
      <div className="d-none d-lg-block"><Footer /></div>
    </div>
  );
}

const AppWrapper = () => {
  return (
    <ErrorBoundary>
      <Router>
        <AppProvider>
          <App />
        </AppProvider>
      </Router>
    </ErrorBoundary>
  );
}

export default AppWrapper;
